import { DeckAction, DeckClown, DeckDrink, DeckTruth, type Deck } from '@/api/generated/game';

/**
 * Как выглядит колода. Ключи совпадают с `game.Deck` из контракта: цвет берётся
 * по `pending.deck`, а не по порядку в списке.
 *
 * Классы записаны целиком, а не собираются из кусков (`bg-${deck}`): Tailwind
 * сканирует исходники строками и вырезал бы такие классы из сборки.
 */
export interface DeckLook {
  title: string;
  emoji: string;
  /** Заливка лица карточки. */
  face: string;
  /** Полоска цвета колоды: столбик остатка, кромка. */
  bar: string;
  text: string;
}

export const DECK_LOOK: Record<Deck, DeckLook> = {
  [DeckTruth]: { title: 'ПРАВДА', emoji: '👀', face: 'bg-truth', bar: 'bg-truth', text: 'text-truth' },
  [DeckAction]: {
    title: 'ДЕЙСТВИЕ',
    emoji: '💃',
    face: 'bg-action',
    bar: 'bg-action',
    text: 'text-action',
  },
  [DeckDrink]: { title: 'АЛКОГОЛЬ', emoji: '🍻', face: 'bg-drink', bar: 'bg-drink', text: 'text-drink' },
  [DeckClown]: { title: 'КЛОУН', emoji: '🤡', face: 'bg-clown', bar: 'bg-clown', text: 'text-clown' },
};

/** Порядок колод один и тот же везде: остаток на ходе, полоса на рубашке. */
export const DECK_ORDER: Deck[] = [DeckTruth, DeckAction, DeckDrink, DeckClown];

export function deckLook(deck: Deck): DeckLook {
  return (
    DECK_LOOK[deck] ?? {
      title: deck.toUpperCase(),
      emoji: '🃏',
      face: 'bg-panel',
      bar: 'bg-line',
      text: 'text-ink',
    }
  );
}
